import { gql } from '@apollo/client'
import { isEmpty } from 'lodash'

import { SALE_STATUS } from 'features/Sales/components/Status/constants'
import { round } from 'utils/math'

export const getLineItemTotal = (lineItem: TSFixMe): TSFixMe => {
  return round(lineItem.quantity * lineItem.unitPrice)
}

export const getLineItemsTotal = (lineItems: TSFixMe): TSFixMe => {
  return lineItems.reduce((result: TSFixMe, lineItem: TSFixMe): TSFixMe => {
    return result + getLineItemTotal(lineItem)
  }, 0)
}

export const getLineItemsDiscount = (lineItems: TSFixMe): TSFixMe => {
  return lineItems.reduce((result: TSFixMe, lineItem: TSFixMe): TSFixMe => {
    return result + lineItem.discount
  }, 0)
}

const SALE_LINE_ITEMS_FRAGMENT = gql`
  fragment SaleLineItems on Sale {
    status
    lineItems {
      itemID
      name
      quantity
      unitPrice
      total
      comboComponents {
        quantity
        item {
          id
          name
        }
      }
    }
  }
`

export const resolvers = {
  Mutation: {
    cancelSaleItems(_root: TSFixMe, { id, cancelledItems }: TSFixMe, { cache }: TSFixMe) {
      const { lineItems } = cache.readFragment({
        id: cache.identify({
          __typename: 'Sale',
          id
        }),
        fragment: SALE_LINE_ITEMS_FRAGMENT
      })

      const newLineItems = lineItems
        .map((lineItem: TSFixMe): TSFixMe => {
          let quantity = lineItem.quantity

          const cancelledItem = cancelledItems.find(({ id }: TSFixMe): TSFixMe => lineItem.itemID === id)

          if (cancelledItem) {
            quantity -= cancelledItem.quantity
          }

          return {
            ...lineItem,
            quantity,
            total: round(quantity * lineItem.unitPrice)
          }
        })
        .filter((lineItem: TSFixMe): TSFixMe => lineItem.quantity > 0)

      cache.writeFragment({
        id: cache.identify({
          __typename: 'Sale',
          id
        }),
        fragment: SALE_LINE_ITEMS_FRAGMENT,
        data: {
          __typename: 'Sale',
          status: isEmpty(newLineItems) ? SALE_STATUS.CANCELLED : SALE_STATUS.CONFIRMED,
          lineItems: newLineItems
        }
      })
      return null
    }
  }
}
